import React from "react";
import Button from "../../shared/Button";
import security  from "../../../assets/img/Home/security-user.png";
import support   from "../../../assets/img/Home/24-support.svg";
import medal   from "../../../assets/img/Home/medal-star.svg";
import hand   from "../../../assets/img/Home/Hand.svg";
import flash from "../../../assets/img/Home/Vector 19.svg"
const Cooprate = () => {
  return (
    <div className="Cooprate relative">
       <div className="">
              <img src={hand} className='hand--cooprate'/>
            </div>
      <div className="container">
        <div className="Cooprate-container">
          <div className="Cooprate-container-title">همکاری با ما</div>
          <div className=" Cooprate-grid" >
           <div></div>
            <div className="relative z-[999]">
              <h3 className="text-[#fff] font-[900] text-[40px] ">چرا در جاتیک میزبان بشم ؟</h3>

              <p className="text-[#fff] font-[500] text-[20px] text-justify mt-[20px] mb-[30px] Cooprate__p ">
                میزبان واقعی جاتیک مردم واقعی هستند که ملک و یا فضای مسکن که بیش
                از نیاز آن ها است را به گردشگران برای جذب درآمد اجاره میدهند .
              </p>
            <div className="flex justify-between Cooprate--space ">
            <Button varient="secondary" className="z-999 relative">شروع همکاری</Button>
            <img className="relative Cooprate--flash z-[999]" src={flash}/>
            </div>
            </div>
            <div className="Cooprate--bg-cons">
              <div className="Cooprate-bg-white">
                <img src={security}/>
                <p>بررسی اطلاعات میزبان‌ها و مهمان‌ها، از مهم‌ترین اقدامات جاتیک است</p>
              </div>
              <div className="Cooprate-bg-white">
                <img src={support}/>
                <p>ما به صورت شبانه‌روزی و در ایام تعطیل آماده پاسخگویی به شما است</p>
              </div>
              <div className="Cooprate-bg-white">
                <img src={medal}/>
                <p>جاتیک مجوزهای لازم برای خدمات گردشگری را با استانداردهای لازم دارد</p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cooprate;
